/** DISCLAIMER
* "Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software.
* Do not copy, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein."
*/

"use strict";

/* global dataLayer cbtSitePreferences customerNumber */
var lo = require("lodash");
let liveClick = [];

var impressionCounter = 0;

class CBTController {
    /**
     * function to push data to the dataLayer, and add hash
     * @param {Object} data - data to push
     */
    static hashPush(data) {
        if (data) {
            if (data.eventTypes) {
                delete data.eventTypes;
            }
            if (data.selector) {
                delete data.selector;
            }
            if ((location.hash.indexOf(data.event + "cbt") == -1)) {
                if (document.readyState === "complete") {
                    dataLayer.push(data);
                } else {
                    window.addEventListener("load", function () {
                        dataLayer.push(data);
                    });
                }
            }
        }
    }

    /**
     * Parse the data object into json
     * @param {String} data
     * @returns {Object} jsonObject
     */
    static parseJSON(data) {
        let parsedJson = {};
        try {
            parsedJson = JSON.parse(data);
        } catch (error) {
            // Handle cases of missing closing quote
            if(data.length > data.lastIndexOf("}")) {
                data = data.substring(0, data.lastIndexOf("}") + 1);
            }
            // eslint-disable-next-line quotes
            data = data || "{}";
            parsedJson = JSON.parse(data.replace(/'/gi,'"').replace(/\\"/,"'"));
        }
        return parsedJson;
    }
    /**
     * check data type and parse string into JSON
     * @param {Object} data - data to push
     */
    static dataPush(data) {
        if ((typeof(data) === "string") && (data != "")) {
            if((data != null) || (data != "null")) {
                data = CBTController.parseJSON(lo.unescape(data));
                CBTController.hashPush(data);
            }
        } else {
            CBTController.hashPush(data);
        }
    }

    /**
     * find, parse and add to dataLayer data-cbt from all tags in node
     * @param {Object} node - DOM node, inside which will be search
     */
    static findAllDataDOM(node) {
        let allCBTData = node.querySelectorAll("[data-cbt]"),
            impressionsContainer = [],
            dataCollectionObj = {};

        if (!allCBTData.length) {
            return false;
        }

        for (let i = 0; i < allCBTData.length; i++) {
            let tempNode = allCBTData[i];
            dataCollectionObj = CBTController.parseJSON(tempNode.getAttribute("data-cbt"));
            if (dataCollectionObj && dataCollectionObj.event === "ImpressionsUpdate" && dataCollectionObj.ecommerce.impressions.position === "") {
                dataCollectionObj.ecommerce.impressions.position = impressionCounter;
                impressionCounter++;
            }

            // Handle Search Bar input
            if (dataCollectionObj && dataCollectionObj.action === "Search" && dataCollectionObj.label) {
                CBTController.dataPush(dataCollectionObj);
            }
            if (dataCollectionObj && dataCollectionObj.event === "view_cart") {
                CBTController.dataPush(dataCollectionObj);
                continue;
            }
            if (!dataCollectionObj || !dataCollectionObj.eventTypes || !dataCollectionObj.event) {
                continue;
            }

            let eventTypes = dataCollectionObj.eventTypes.split(",");

            if (eventTypes.indexOf("show") != -1) {
                // Handle show events that appered as a result of a click in specific cases
                // i.e. Add Coupon in SG. That way they will appear as Click event.
                if (dataCollectionObj.eventTypes.indexOf("click") !== - 1) {
                    dataCollectionObj.category = "Click";
                    CBTController.dataPush(dataCollectionObj);
                    continue;
                }
                if (dataCollectionObj.event.indexOf("show") == -1) {
                    dataCollectionObj.event = "show" + dataCollectionObj.event;
                }
                if (dataCollectionObj.event == "showImpressionsUpdate") {
                    impressionsContainer.push(dataCollectionObj.ecommerce.impressions);
                } else {
                    CBTController.dataPush(dataCollectionObj);
                }
                tempNode.removeAttribute("data-cbt");
            }
        }

        if (impressionsContainer.length > 0) {
            let dataLayerObj = {
                "event" : "showImpressionsUpdate",
                "ecommerce": {}
            };
            dataLayerObj.ecommerce.impressions = impressionsContainer;
            CBTController.dataPush(dataLayerObj);
        }
    }

    /* Update Product Tile data-cbt attribute with actual position so it works with "Show more" feature */
    static updateTilesPosition(nodes) {
        var productCollection = [];
        var productCounter = -1;

        for (let i = 0; i < nodes.length; i++) {
            let tempNode = nodes[i];
            var dataCollectionObj = CBTController.parseJSON(tempNode.getAttribute("data-cbt"));
            if (dataCollectionObj && dataCollectionObj.event === "showProductClick") {
                if (productCollection.indexOf(dataCollectionObj.ecommerce.click.products[0].id) === -1) {
                    productCollection.push(dataCollectionObj.ecommerce.click.products[0].id);
                    productCounter++;
                }
                if (dataCollectionObj.ecommerce.click.products[0].position === "") {
                    dataCollectionObj.ecommerce.click.products[0].position = productCounter;
                }
                tempNode.dataset.cbt = JSON.stringify(dataCollectionObj);
            }
        }
    }

    static sendVisiblePromoViewFromViewport(node) {
        let nodes = [];
        let promotionsContainer = {
            "event" : "promotionView",
            "ecommerce": {
                "promoView": {
                    "promotions": []
                }
            }
        };

        if (node) {
            nodes[0] = node;
            promotionsContainer.event = "promotionClick";
        } else {
            nodes = document.querySelectorAll("[data-promoview-name]");
        }

        if (!nodes.length) {
            return false;
        }

        let promotions = promotionsContainer.ecommerce.promoView.promotions;
        let promoViewAdded = dataLayer.filter(data => data.event === 'promotionView');

        for (let i = 0; i < nodes.length; i++) {
            let tempNode = nodes[i];
            let dataset = tempNode.dataset;

            if (tempNode.closest('[data-contentid]') === null ||
                dataset.promoviewName === '' ||
                tempNode.classList.contains('slick-cloned') ||
                tempNode.closest('.slick-cloned') ||
                tempNode.classList.contains('slick-slide') && !tempNode.classList.contains('slick-active') ||
                tempNode.closest('.slick-slide') && !tempNode.closest('.slick-slide').classList.contains('slick-active')) {
                continue;
            }

            let dataCollectionObj = {
                "event" : "promotionView",
                "ecommerce": {
                    "promoView": {
                        "promotions": [{
                            "id": tempNode.closest('[data-contentid]').dataset.contentid,
                            "name": dataset.promoviewName,
                            "creative": dataset.promoviewCreative
                        }]
                    }
                }
            };

            if ($(tempNode).css('visibility') === "visible" && $(tempNode).isInViewport()) {
                let promotionToBeAdded = dataCollectionObj.ecommerce.promoView.promotions[0];

                // Add promotion at load and if are in the viewport
                if (promoViewAdded.length === 0) {
                    promotions.push(promotionToBeAdded);
                } else {
                    // Check if promotion was already added in dataLayer
                    let alreadyInDataLayer = promoViewAdded.filter(data => data.ecommerce.promoView.promotions.find(data => data.name === promotionToBeAdded.name && data.id === promotionToBeAdded.id)).length > 0;

                    if (!alreadyInDataLayer) {
                        promotions.push(promotionToBeAdded);
                    }
                }

                // If click send the promotion all the time
                if (node) {
                    promotions.push(promotionToBeAdded);
                }
            }
        }

        if (promotions.length > 0) {
            // Set position
            promotionsContainer.ecommerce.promoView.promotions.forEach(function(el, index) {
                el.position = index + 1;
            });

            CBTController.dataPush(promotionsContainer);
            promotions = [];
        }
    }

    /**
     *  if "link" option enable, set same "data-cbt" to all node childNodes,
     *  to have the same event in clickListenerRun and hoverListenerRun
     */
    static handleLinks(node) {
        const allCBTData = node.querySelectorAll("[data-cbt]");

        if (!allCBTData.length) {
            return false;
        }

        // Call updateTilesPosition to avoid querying document another time
        CBTController.updateTilesPosition(allCBTData);

        function setChildData(childs, data) {
            for (let i = 0; i < childs.length; i++) {
                if (childs[i].nodeType == 1) {
                    if (childs[i].getAttribute("data-cbt")) continue;
                    childs[i].setAttribute("data-cbt", data);
                    if (childs[i].childNodes.length) {
                        setChildData(childs[i].childNodes, data);
                    }
                }
            }
        }

        for (let i = 0; i < allCBTData.length; i++) {
            let tempNode = allCBTData[i];
            const dataStr = tempNode.getAttribute("data-cbt");
            const dataObj = CBTController.parseJSON(dataStr);

            if (!dataObj) continue;

            if (typeof dataObj.eventTypes !== "undefined" && dataObj.eventTypes.indexOf("link") != -1) {
                if (tempNode.childNodes.length) {
                    setChildData(tempNode.childNodes, dataStr);
                }
            }

            if (typeof dataObj.eventTypes !== "undefined" && dataObj.eventTypes.indexOf("add") != -1) {
                let dynamicNodes = document.querySelectorAll(dataObj.selector);
                if (dynamicNodes.length) {
                    for (let j = 0; j < dynamicNodes.length; j++) {
                        let tempDynamicNode = dynamicNodes[j];
                        let dataObj = CBTController.parseJSON(dataStr);
                        let eventTypes = dataObj.eventTypes.split(",");
                        eventTypes.splice(eventTypes.indexOf("add"), 1);
                        dataObj.eventTypes = eventTypes.join(",");
                        tempDynamicNode.setAttribute("data-cbt", JSON.stringify(dataObj));
                    }
                    tempNode.removeAttribute("data-cbt");
                }
            }
        }
    }

    static clickHandler(event) {
        if (event && event.target && event.target.getAttribute("data-cbt")) {
            let node = event.target;
            let data = CBTController.parseJSON(node.getAttribute("data-cbt"));
            if (data && data.eventTypes && data.eventTypes.indexOf("click") != -1) {

                if (data.event !== "showProductClick" && data.event !== "view_search_results") {
                    setActionCategory(data, "click");
                }

                if (liveClick.indexOf(data.event) == -1) {
                    liveClick.push(data.event);
                    setTimeout(function () {
                        liveClick.splice(liveClick.indexOf(data.event), 1);
                    }, 10);
                } else {
                    return;
                }
                CBTController.dataPush(data);
            }
        }
    }

    /**
     * run AJAX listener, to find all (cbt_data in JSON) or (data-cbt in HTML) sent via XMLHttpRequest
     */
    static AJAXListenerRun() {
        var listenerSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function() {
            var callback = this.onreadystatechange;
            this.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    if (this.getAllResponseHeaders().indexOf("application/json") != -1) {
                        var myArr = CBTController.parseJSON(this.responseText);
                        if (myArr.cbt_data) {
                            CBTController.dataPush(myArr.cbt_data);
                        }
                    }

                    if (this.getAllResponseHeaders().indexOf("text/html") != -1) {
                        var container = document.implementation.createHTMLDocument("").documentElement;
                        container.innerHTML = this.responseText;
                        CBTController.findAllDataDOM(container);
                    }
                }
                if (callback) {
                    callback.apply(this, arguments);
                }
            };
            listenerSend.apply(this, arguments);
        };
    }

    //run DOM updates listener, to find all cbt-data added to DOM
    static DOMListenerRun() {
        var timeout = null;
        let observer = new MutationObserver(function() {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function() {
                CBTController.handleLinks(document);
            }, 1000);
        });
        const targetNode = document.body;
        const config = { childList: true, subtree: true };
        observer.observe(targetNode, config);
    }

    static clickListenerRun() {
        let allContainers = document.querySelectorAll("body,.container");
        for (let i = 0; i < allContainers.length; i++) {
            let tempNode = allContainers[i];
            tempNode.addEventListener("click", function(event) {
                CBTController.clickHandler(event);
            });

            // Added custom event for CBT Click for the stop propagation case
            $(tempNode).on('CBTClick', function(event) {
                CBTController.clickHandler(event);
            });
        }
    }

    static changeListenerRun() {
        document.addEventListener("change", function(event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                let node = event.target,
                    data = CBTController.parseJSON(node.getAttribute("data-cbt"));
                if (data && data.eventTypes && data.eventTypes.indexOf("change") != -1) {
                    if (node.options) {
                        data.label = node.options[node.options.selectedIndex].text;
                    }
                    if (typeof node.attributes["type"] !== "undefined" && node.attributes["type"]["nodeValue"] == "checkbox") {
                        if (!data.label) {
                            data.label = node.checked ? "checked" : "unchecked";
                        }
                    }
                    if (!data.label) {
                        data.label = node.value;
                    }
                    if (!data.action) {
                        data.action = "change";
                    }
                    data.category = "Click";

                    CBTController.dataPush(data);
                }
            }
        });
    }

    static hoverListenerRun() {
        let timeout = null;
        document.addEventListener("mouseover", function(event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                const hoverDelay = cbtSitePreferences.CBT_HOVER_DELAY || 1000; // delay for hover event (ms)
                let node = event.target,
                    data = CBTController.parseJSON(node.getAttribute("data-cbt"));
                if (!data){
                    return;
                }
                if (data.eventTypes && data.eventTypes.indexOf("hover") != -1) {
                    timeout = setTimeout(function () {
                        if (node.options) {
                            data.label = node.options[node.options.selectedIndex].text;
                        }
                        
                        if (data.event !== "view_search_results") {
                            setActionCategory(data, "hover");
                        }

                        CBTController.dataPush(data);
                    }, hoverDelay);
                }
            }
        });

        document.addEventListener("mouseout", function(event) {
            if (event && event.target && event.target.getAttribute("data-cbt")) {
                clearTimeout(timeout);
            }
        });
    }

    static scrollListenerRun () {
        document.addEventListener('scroll', lo.debounce(function() {
            CBTController.sendVisiblePromoViewFromViewport();
        }), 500, {leading:true, trailing:false});
    }

    // Push data which specifies customer's number if they're logged in, otherwise specify "Anonymous"
    static clientNumberRun() {
        var data = {};
        if (window.customerNumber) {
            data.customerID = customerNumber;
        } else {
            data.customerID = "Anonymous";
        }
        CBTController.dataPush(data);
    }

    static customEvents() {
        $(document).on('sendVisiblePromoViewFromViewport', function() {
            CBTController.sendVisiblePromoViewFromViewport();
        });

        $(document).on('click.promoView', function(event) {
            if (event && event.target && event.target.closest('[data-promoview-name]')) {
                CBTController.sendVisiblePromoViewFromViewport(event.target.closest('[data-promoview-name]'));
            }
        });
    }
}

/**
 * Sets the action and category properties of the data object based on the event type.
 *
 * @param {Object} data - The data object to be modified.
 * @param {string} eventType - The type of the event (e.g., "click", "hover").
 */
function setActionCategory(data, eventType) {
    if (!data || !eventType) {
        return;
    }

    if (!data.action) {
        data.action = eventType;
    }

    data.category = eventType.charAt(0).toUpperCase() + eventType.slice(1);
}

/**
 * initial cbt-data search and dataLayer push on page
 * AJAX listener run
 */

document.addEventListener("DOMContentLoaded", function() {
    CBTController.customEvents();
    CBTController.clientNumberRun();
    CBTController.findAllDataDOM(document);
    CBTController.AJAXListenerRun();
    CBTController.DOMListenerRun();
    CBTController.sendVisiblePromoViewFromViewport();

    if (cbtSitePreferences.CBT_SCROLL) {
        CBTController.scrollListenerRun();
    }

    if (cbtSitePreferences.CBT_CLICK) {
        CBTController.clickListenerRun();
        CBTController.changeListenerRun();
    }

    if (cbtSitePreferences.CBT_HOVER) {
        CBTController.hoverListenerRun();
    }
});

